<script lang="ts">
  import {onMount} from 'svelte';
  import type {Writable} from 'svelte/store';
  import {incentivePlans} from 'Store/deals/incentivePlan';
  import {humanShortDate} from 'Utility/formatters/dates';
  import type {IncentivePlanStore} from 'Store/deals/incentivePlan';
  import type {Deal} from 'Utility/investorFlow/entity';
  import {deal, fetchDeal} from 'Store/ibex/checkouts/investorCheckoutStore';
  import {openLinksInNewTab} from 'Utility/formatters/replaceAnchorTags';

  export let dealId: string | number;
  export let incentivePlanStore: IncentivePlanStore = incentivePlans;
  export let dealStore: Writable<Deal> = deal;

  let content: string;

  onMount(() => {
    if (!!dealId && !$incentivePlanStore) {
      incentivePlanStore.load(dealId);
    }

    if (!!dealId && !$dealStore) {
      fetchDeal(String(dealId));
    }
  });

  $: loading = !$incentivePlanStore || !$dealStore;

  $: endAt = humanShortDate($incentivePlanStore?.effective_tier?.end_at);
  $: fundedBy = humanShortDate($incentivePlanStore?.effective_tier?.funded_by);
  $: incentivePlanContent = $dealStore?.setting?.incentive_plan_content;
  $: content = incentivePlanContent
    ? <string>(
        openLinksInNewTab(
          incentivePlanContent
            .replace('[tier_end_at]', endAt)
            .replace('[tier_funded_by]', fundedBy)
        )
      )
    : null;
</script>

{#if $incentivePlanStore?.effective_tier && incentivePlanContent}
  <div
    class="incentive-description"
    class:skeleton={loading}
    data-testid="disclaimer-component"
  >
    <span class="skeleton-text">
      {@html content}
    </span>
  </div>
{/if}

<style lang="postcss">
  .incentive-description {
    color: #667085;
    font-size: 0.75rem;
    font-style: normal;
    font-weight: 400;
    line-height: 1.125rem;
    margin-top: 1rem;
  }

  .skeleton {
    border-radius: 1rem;
    background: #f0f0f0;
    overflow: hidden;
    position: relative;

    & .skeleton-text {
      color: transparent;
      background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
      background-size: 200% 100%;
      animation: shimmer 1.5s infinite;
    }
  }

  @keyframes shimmer {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }

  .skeleton {
    & a {
      display: none;
    }
  }
</style>
